<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>1、ship name/IMO Number/Flag/Port Of registry（船名/IMO编号/船旗国/注册港）</span>
				<span>{{ data1.jz001 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz002 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz003" />
			</li>
			<li>
				<span>2、Call Sign（船舶呼号）</span>
				<span>{{ data1.jz004 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz005 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz006" />
			</li>
			<li>
				<span>3、GRT/NRT/DWT（总注册吨位/净注册吨位/载重公吨）</span>
				<span>{{ data1.jz007 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz008 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz009" />
			</li>
			<li>
				<span>4、LOA/Breadth/Depth（船长/船宽/型深）</span>
				<span>{{ data1.jz010 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz011 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz012" />
			</li>
			<li>
				<span>5、Port of loading（装货港）</span>
				<span>{{ data1.jz013 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz014 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz015" />
			</li>
			<li>
				<span>6、Port of discharging（卸货港）</span>
				<span>{{ data1.jz016 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz017 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz018" />
			</li>
			<li>
				<span>7、End of sea passage time（结束海上机动航行时间）</span>
				<span>{{ data1.jz019 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz020 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz021" />
			</li>
			<li>
				<span>8、all fast time（全部缆绳带好时间）</span>
				<span>{{ data1.jz022 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz023 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz024" />
			</li>
			<li>
				<span>9、commenced loading time（开始装货时间）</span>
				<span>{{ data1.jz025 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz026 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz027" />
			</li>
			<li>
				<span>10、completed loading time（结束装货时间）</span>
				<span>{{ data1.jz028 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz029 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz030" />
			</li>
			<li>
				<span>11、completed lashing time（绑扎结束时间）</span>
				<span>{{ data1.jz031 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz032 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz033" />
			</li>
			<li>
				<span>12、receivers（收货人公司名称）</span>
				<span>{{ data1.jz034 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz035 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz036" />
			</li>
			<li>
				<span>13、seller name（卖家公司名称）</span>
				<span>{{ data1.jz037 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz038 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz039" />
			</li>
			<li>
				<span>14、trader name（贸易商公司名称）</span>
				<span>{{ data1.jz040 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz041 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz042" />
			</li>
			<li>
				<span>15、Pieces /weight manifest（件数/吨位）</span>
				<span>{{ data1.jz043 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz044 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz045" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workStart1',
	components: {
		navTop
	},
	data() {
		return {
			data1: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejz();
		}
	},
	methods: {
		getSchedulejz() {
			let data = {
				id: this.id
			};
			this.$api.schedulejz(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.data1 = res.data;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		// p {
		// 	color: #00fff0;
		// 	font-size: 25px;
		// 	line-height: 1em;
		// 	text-align: center;
		// 	font-weight: bold;
		// 	margin-bottom: 10px;
		// }
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
